<template>

    <div class="col">
        <p class="step-caption ft-bld">Upload the video for this content</p>
        <div class="vid-up-wrapper">
            <Uploader caption="" type="video" custom-clear v-model="video" @input="handleVideoUpload" class="vid"></Uploader>
        </div>

        <template v-if="video">
            <p class="step-caption ft-bld">Chose an auto generated cover or upload your own image</p>
            <div class="cover-wrapper">

                <div class="cover-card" :class="{ active : activePoster == index}" @click.prevent="posterPick(index)" v-for="cover, index in autoCovers" :key="index">
                    <div class="pic cvr" :style="{backgroundImage: 'url('+cover+')'}"></div>
                    <span class="icon"></span>
                </div>

                <div class="cover-card up" :class="{ active : poster && activePoster == 4 }">

                    <div class="frt" v-show="poster && activePoster != 4" @click.prevent="handlePosterUpload"></div>

                    <Uploader :caption="null" custom-caption="Upload an image" custom-clear v-model="poster" @input="handlePosterUpload" class="vid pstr"></Uploader>

                    <span class="icon"></span>

                    <!-- <div v-if="activePoster == 4">
                        <div class="pic cvr" style="background-image:url('/img/dashboard/posters/e.jpg')"></div>
                        <span class="icon"></span>
                        <span class="del" @click.prevent="delUp">
                            <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 2H16.5C17.3284 2 18 2.67157 18 3.5C18 4.32843 17.3284 5 16.5 5H16V16C16 17.6569 14.6569 19 13 19H5C3.34315 19 2 17.6569 2 16V5H1.5C0.671573 5 0 4.32843 0 3.5C0 2.67157 0.671573 2 1.5 2H5C5 0.895431 5.89543 0 7 0H11C12.1046 0 13 0.895431 13 2ZM5 14.5C5 15.3284 5.67157 16 6.5 16C7.32843 16 8 15.3284 8 14.5V8.5C8 7.67157 7.32843 7 6.5 7C5.67157 7 5 7.67157 5 8.5V14.5ZM11.5 16C10.6716 16 10 15.3284 10 14.5V8.5C10 7.67157 10.6716 7 11.5 7C12.3284 7 13 7.67157 13 8.5V14.5C13 15.3284 12.3284 16 11.5 16Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                    <div class="col plchldr" v-else>
                        <span class="icon"></span>
                        <p class="txt ft-bld txt-main">Upload an image</p>
                    </div> -->

                </div>
            </div>
        </template>
        
        <div class="nxt-out">
            <div class="btn bck" @click.prevent="switchStep('prv')">
                <span class="txt">Back</span>
            </div>
            <div class="btn main txt-blk" @click.prevent="switchStep('nxt')">
                <span class="hvr"></span>
                <span class="txt">Continue</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import Uploader from '../../components/Uploader'

    export default {

        name: 'NewContentTwo',

        components: {
            Uploader
        },

        data() {
            return {
                Global,
                activePoster: null,

                video: null,
                poster: null
            }
        },

        computed: {

            autoCovers() {
                
                if(!this.video) return []

                const videoConfig = this.Global.videoConfigs.find((config) => {
                    return config.filename === this.video.file.name
                })

                return videoConfig ? videoConfig.covers : []
            }
        },

        methods: {

            posterPick(num) {
                this.activePoster = num
                this.Global.newContentOverlay.poster = this.autoCovers[num]
            },

            delUp() {
                // deletion jerem magic
                this.activePoster = 1
            },

            switchStep(dir) {
                this.$emit(dir)
            },

            handleVideoUpload() {
                this.activePoster = null
                this.Global.newContentOverlay.poster = null
                this.Global.newContentOverlay.video = this.video ? this.video.previewSrc : null
            },

            handlePosterUpload() {
                this.activePoster = null
                this.activePoster = 4
                this.Global.newContentOverlay.poster = this.poster ? this.poster.previewSrc : null
            },

            // backToUploadedPoster() {
            //     this.activePoster = 4
            //     this.Global.newContentOverlay.poster = this.poster
            // }

        }
    }

</script>